<ng-template #template>
    <div class="notify">
        <nz-spin nzSimple></nz-spin>
        <span class="subtitle">{{ 'export-column-names.notification-msg' | translate }}</span>
    </div>
</ng-template>
<ng-template #limitTemplate>
    <div class="notify">
        <span class="subtitle">{{ 'export-column-names.notification-limit-msg' | translate }}</span>
    </div>
</ng-template>
<button
    class="download"
    type="button"
    nz-button
    nzType="default"
    nz-dropdown
    nzTrigger="click"
    adsptHeap="table-download-expand"
    [heapData]="heapData"
    [nzDropdownMenu]="exportMenu"
    nzPlacement="bottomRight"
>
    <adspt-icon [name]="icon" size="14px" />
</button>
<div id="temp" style="display: none"></div>
<nz-dropdown-menu #exportMenu="nzDropdownMenu">
    <div class="chart-export-wrapper">
        <ul nz-menu>
            <li
                nz-menu-item
                *ngFor="let item of export"
                adsptHeap="table-download-select"
                [heapData]="getExtraHeapData({ type: item.key })"
                (click)="onExport(item)"
                class="item"
            >
                <span class="p1">{{ item.name }}</span>
            </li>
        </ul>
    </div>
</nz-dropdown-menu>

<adspt-toaster
    *ngIf="errorToast"
    duration="3000"
    type="error"
    title="{{ 'common.error-msg' | translate }}"
    (closed)="errorToast = false"
/>
